
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.869 13.062a.68.68 0 00.492-.204.658.658 0 00.208-.488v-9.1l-.053-1.33.593.63 1.347 1.435a.607.607 0 00.479.213c.183 0 .337-.06.46-.177a.597.597 0 00.187-.452.577.577 0 00-.213-.46L8.374.238a.873.873 0 00-.253-.186.636.636 0 00-.514 0 .873.873 0 00-.252.186L4.36 3.128a.577.577 0 00-.213.46c0 .184.06.335.182.453a.627.627 0 00.456.177c.201 0 .363-.07.487-.213L6.62 2.57l.594-.63-.053 1.33v9.1c0 .19.07.352.208.488a.69.69 0 00.5.204zM12.946 20c.928 0 1.623-.23 2.087-.691.464-.461.696-1.146.696-2.056V8.409c0-.91-.232-1.595-.696-2.055-.463-.461-1.16-.692-2.087-.692h-2.472V7.09h2.446c.437 0 .777.118 1.019.355.242.236.363.584.363 1.045v8.684c0 .461-.12.81-.363 1.046-.242.236-.582.354-1.02.354H2.8c-.443 0-.783-.118-1.019-.354-.236-.236-.354-.585-.354-1.046V8.49c0-.46.118-.81.354-1.045.236-.237.576-.355 1.02-.355h2.454V5.662H2.782c-.927 0-1.623.23-2.086.687C.232 6.807 0 7.494 0 8.41v8.844c0 .916.232 1.602.696 2.06.463.458 1.159.687 2.086.687h10.164z","fill":"#F9FAFB"}})])
          )
        }
      }
    